import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";

import { creaUsuario } from "../../Services/Rest";

ReactModal.setAppElement("#root");

function CrearUsuario({ onCreate }) {
  const [isOpen, setIsOpen] = useState(false);

  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [tipo, setTipo] = useState(null);

  // 🔹 opciones tipo usuario
  const tiposUsuario = [
    { value: 1, label: "Administrador" },
    { value: 0, label: "Usuario" },
  ];

  // 🔥 GUARDAR
  const postData = (e) => {
    e.preventDefault();

    if (!nombre || !correo || !tipo) {
      return Swal.fire(
        "Campos requeridos",
        "Complete todos los campos",
        "warning",
      );
    }

    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "post",
      url: creaUsuario,
      data: {
        nombre,
        correo,
        tipo: tipo.value,
      },
    })
      .then((res) => {
        setIsOpen(false); // 🔥 cerrar primero

        Swal.fire({
          title: "Éxito",
          text: res.data,
          icon: "success",
          confirmButtonText: "Aceptar",
        }).then(() => {
          // 🔥 SIN RECARGAR SI VIENE PROP
          if (onCreate) {
            onCreate();
          } else {
            window.location.reload();
          }
        });
      })
      .catch(() => {
        setIsOpen(false);

        Swal.fire("Error", "No se pudo crear el usuario", "error");
      });
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        + Nuevo Usuario
      </button>

      <ReactModal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        className="modal-xl"
        overlayClassName="overlay-xl"
      >
        {/* 🔥 HEADER */}
        <div className="modal-header-xl">
          <h3>Crear Usuario</h3>
          <button onClick={() => setIsOpen(false)}>✕</button>
        </div>

        {/* 🔥 FORM */}
        <form className="modal-body-xl" onSubmit={postData}>
          <div className="grid-form">
            <div>
              <label>Nombre</label>
              <input
                type="text"
                className="form-control"
                placeholder="Ingrese nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </div>

            <div>
              <label>Correo</label>
              <input
                type="email"
                className="form-control"
                placeholder="Ingrese correo"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
              />
            </div>

            <div style={{ gridColumn: "span 2" }}>
              <label>Tipo de Usuario</label>
              <Select
                options={tiposUsuario}
                value={tipo}
                onChange={setTipo}
                placeholder="Seleccione tipo..."
                isSearchable
              />
            </div>
          </div>

          {/* 🔥 ACCIONES */}
          <div className="actions-xl">
            <button type="button" onClick={() => setIsOpen(false)}>
              Cancelar
            </button>

            <button type="submit" className="btn-save-xl">
              Guardar
            </button>
          </div>
        </form>
      </ReactModal>
    </div>
  );
}

export default CrearUsuario;
